import type { Alias } from '@ps/web-core-store';
import { isEmpty } from 'lodash';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { stripRouteParams } from '@swf/core/utils/stripRouteParams';

import type { InviteLink } from '../../types/common';

import useGetArgs from './useGetArgs';

const redirectRoutes: Record<InviteLink, Alias> = {
  JOIN_CLUB: 'homeGamesClubs'
};

const Invite: React.FC = () => {
  const { args: state, urlParams } = useGetArgs();
  const aliases = useSelector(select.cms.getAliases);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const hasClientSession = useSelector(select.session.hasClientSession);
  const history = useHistory();
  const { modal } = useDispatch<Dispatch>();
  const noState = isEmpty(state);

  urlParams.delete('args');
  const search = urlParams.toString();

  useEffect(() => {
    if ((isAuthenticated && hasClientSession) || noState) return;

    modal.unique({ path: '/auth/login' });
  }, [hasClientSession, isAuthenticated, modal, noState]);

  useEffect(() => {
    if (!isAuthenticated || !hasClientSession || noState) return;
    const pathname = aliases[redirectRoutes[state.type]] ?? '';
    history.replace({ pathname: stripRouteParams(pathname), state, search });

    return () => history.replace({ state: {}, search });
  }, [state, history, aliases, search, isAuthenticated, noState, hasClientSession]);

  return null;
};

export default Invite;
